import * as React from "react"

const RatingSvg = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.04897 0.926956C7.34897 0.00595605 8.65197 0.00595605 8.95097 0.926956L10.021 4.21896C10.0863 4.41944 10.2134 4.59414 10.384 4.71806C10.5547 4.84199 10.7601 4.9088 10.971 4.90896H14.433C15.402 4.90896 15.804 6.14896 15.021 6.71896L12.221 8.75296C12.05 8.87699 11.9227 9.05197 11.8573 9.25281C11.7919 9.45365 11.7918 9.67004 11.857 9.87096L12.927 13.163C13.227 14.084 12.172 14.851 11.387 14.281L8.58697 12.247C8.41618 12.123 8.21053 12.0562 7.99947 12.0562C7.78842 12.0562 7.58277 12.123 7.41197 12.247L4.61197 14.281C3.82797 14.851 2.77397 14.084 3.07297 13.163L4.14297 9.87096C4.20815 9.67004 4.20803 9.45365 4.14264 9.25281C4.07725 9.05197 3.94994 8.87699 3.77897 8.75296L0.979974 6.71996C0.196974 6.14996 0.599974 4.90996 1.56797 4.90996H5.02897C5.24002 4.91001 5.44568 4.84329 5.6165 4.71935C5.78732 4.59541 5.91455 4.42061 5.97997 4.21996L7.04997 0.927956L7.04897 0.926956Z"></path>
    <defs>
      <linearGradient id="half-star-gradient">
        <stop stopColor="#453DD8" />
        <stop offset="0.4836" stopColor="#453DD8" />
        <stop offset="0.484322" stopColor="#453DD8" stopOpacity="0" />
        <stop stopColor="#e5e7eb" />
      </linearGradient>
    </defs>
  </svg>
)

const Rating = ({ rating = 4.5 }) => {
  const fillType = value => {
    if (rating >= value) {
      return "customer-ratings__star--full"
    } else if (rating < value && rating > value - 1) {
      return "customer-ratings__star--half"
    }
    return ""
  }
  return (
    <ul className="customer-ratings__stars">
      {Array.from({ length: 5 }, (v, k) => (
        <li key={k} className={`customer-ratings__star ${fillType(k + 1)}`}>
          <RatingSvg />
        </li>
      ))}
    </ul>
  )
}

export default Rating
